import { v4 as uuid } from 'uuid';
export var convertGroups = function convertGroups(groups) {
  return groups.map(function (property) {
    return {
      id: uuid(),
      property: property
    };
  });
};